import graciePic from "@/public/images/artists/gracie.png";
import { Artist } from "@/types/types";

export const gracie = {
  id: "143",
  name: "Gracie",
  image: graciePic,
  description: `Gracie's voice has a soothing, melodic quality, with a touch of huskiness that adds depth and character. She sings with precise enunciation and a steady, confident rhythm that makes her voice clear and appealing. It's a perfect fit for genres like jazz, country, and dance.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fgracie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Jazz",
        "Country",
        "Soul",
        "Indie",
        "Pop",
        "Dance",
        "Unprocessed",
        "Falsetto",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 56,
        high: 76,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
